import React from 'react';
import styles from './currensy-sign.scss';
import { CURRENCIES, DEFAULT_CURRENCY, } from '@wix/wix-vod-constants/common';
export class CurrencySign extends React.Component {
    render() {
        const { currency } = this.props;
        return (React.createElement("div", { className: styles.currencySign, "data-hook": "currency-symbol" }, CURRENCIES[currency ?? DEFAULT_CURRENCY].symbol));
    }
}
//# sourceMappingURL=currency-sign.js.map